import { FolderIcon } from "@phosphor-icons/react";
import { Avatar, theme } from "antd";
import { Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { radius } from "@libertify/ui";

export const EmptyList = ({
  children,
  title,
  description,
}: {
  children?: React.ReactNode;
  title?: string;
  description?: string;
}) => {
  const { theme } = useAntTheme();
  return (
    <Flex
      vertical
      gap={15}
      align="center"
      justify="center"
      style={{
        width: "100%",
        backgroundColor: "#F3F4F6",
        padding: "50px 0",
        border: "1px dashed #f0f0f0",
        borderRadius: radius.box,
      }}
    >
      <Avatar
        size={48}
        icon={<FolderIcon size={24} color={theme.colorText} />}
        style={{ backgroundColor: "#F7F8FB", border: `1px solid #00000014` }}
      />
      {title && (
        <Typography.Title style={{ margin: 0 }} level={2}>
          {title}
        </Typography.Title>
      )}
      {description && (
        <Typography.Text
          style={{ width: "400px", textAlign: "center" }}
          type="secondary"
        >
          {description}
        </Typography.Text>
      )}
      {children}
    </Flex>
  );
};
